import i18n from "i18next";

// i18n.t(key, { defaultValue }) for the talking-avatar UI, with a fallback of
// our own: before i18next is initialised (and in unit tests) t() returns
// undefined, and a missing key must still show the default (Turkish) copy.
const interpolate = (s, vars) =>
  vars
    ? String(s).replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : ""))
    : String(s);

export function tt(key, defaultValue, vars) {
  let out;
  try {
    out = i18n.t(key, { ...(vars || {}), defaultValue });
  } catch (e) {
    out = undefined;
  }
  if (typeof out === "string" && out && out !== key) return out;
  return interpolate(defaultValue, vars);
}
